import { c as _c } from "react/compiler-runtime";
import { Box, Button, Collapsible, Heading, HStack, Image, SimpleGrid, Stack, Text, useDisclosure, VStack } from '@chakra-ui/react';
import { useConversionProducts } from '@src/components/sco/Conversion/controller/useConversionProducts';
import { ChevronDownIcon, ChevronRightIcon } from '@src/components/sco/icons';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import React from 'react';
const LIFETIME_PRODUCT_ID = 'scom-accelerator-advisor-investor-matching-pro-one';
export const ProPricingBlock = () => {
  const $ = _c(39);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [LIFETIME_PRODUCT_ID];
    t1 = {
      termId: "year"
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const {
    products
  } = useConversionProducts(t0, t1);
  const signupCents = products[0]?.effectivePricingInCents?.signup ?? products[0]?.pricingInCents?.signup;
  let t2;
  if ($[2] !== signupCents) {
    t2 = signupCents != null ? (signupCents / 100).toLocaleString("en-US") : "\u2014";
    $[2] = signupCents;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const priceDollars = t2;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const {
    open,
    onToggle
  } = useDisclosure();
  const t3 = open ? "colorPalette.bg" : "colorPalette.muted";
  const t4 = open ? "colorPalette.border" : "transparent";
  let t5;
  if ($[4] !== getBreakpointValue) {
    t5 = getBreakpointValue(["xl", "2xl", "3xl"]);
    $[4] = getBreakpointValue;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Box as="span" background="teal.focusRing" borderRadius="xs" color="black" fontSize="md" fontWeight="bold" marginLeft={1} paddingX={2} textAlign="center" textTransform="uppercase">Pro</Box>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5) {
    t7 = <Heading marginTop={4} size={t5} textAlign="center">{"Investor Matching"}{" "}{t6}</Heading>;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== getBreakpointValue) {
    t8 = getBreakpointValue(["md", "lg", "xl"]);
    $[9] = getBreakpointValue;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = <Text color="colorPalette.fg/70" fontSize={t8} marginY={2} maxWidth="650px" textAlign="center">Supercharge your fundraise with live guidance from our funding experts, twice the number of investor contacts, and in-depth pitch deck review.</Text>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Text color="colorPalette.text" fontSize="xl" fontWeight="bold" paddingTop={2.5}>$</Text>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== priceDollars) {
    t11 = <HStack align="flex-start" gap={1}>{t10}<Text color="colorPalette.text" fontSize="5xl" fontWeight="bold" opacity={1}>{priceDollars}</Text></HStack>;
    $[14] = priceDollars;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Text fontSize="xs" fontWeight="500" marginBottom={2} opacity={0.5} textAlign="center">Includes Lifetime Access to Investor Matching + 1 Year of Complimentary Advisor Access.</Text>;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <ChevronDownIcon />;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== onToggle) {
    t14 = <Button size="lg" variant="outline" onClick={onToggle}>Learn More{t13}</Button>;
    $[18] = onToggle;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Button asChild={true} size="lg" variant="cta"><NextLink href={`/investors/matching/payment?productId=${LIFETIME_PRODUCT_ID}&termId=year`}>Select<ChevronRightIcon /></NextLink></Button>;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t14) {
    t16 = <HStack marginTop={4}>{t14}{t15}</HStack>;
    $[21] = t14;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== getBreakpointValue) {
    t17 = getBreakpointValue([1, 2, 2, 2]);
    $[23] = getBreakpointValue;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = [...Array(6)].map(_temp);
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== t17) {
    t19 = <Collapsible.Content><Box width="full"><SimpleGrid columns={t17} gap={2} marginTop={6}>{t18}</SimpleGrid></Box></Collapsible.Content>;
    $[26] = t17;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== open || $[29] !== t19) {
    t20 = <Box width="full"><Collapsible.Root open={open}>{t19}</Collapsible.Root></Box>;
    $[28] = open;
    $[29] = t19;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== t11 || $[32] !== t16 || $[33] !== t20 || $[34] !== t3 || $[35] !== t4 || $[36] !== t7 || $[37] !== t9) {
    t21 = <Box><Stack align="center" background={t3} border="1px solid" borderColor={t4} borderRadius="xl" boxShadow="lg" padding={10} transition="all 0.3s ease-in-out" width="full">{t7}{t9}{t11}{t12}{t16}{t20}</Stack></Box>;
    $[31] = t11;
    $[32] = t16;
    $[33] = t20;
    $[34] = t3;
    $[35] = t4;
    $[36] = t7;
    $[37] = t9;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  return t21;
};
const PricingCardContent = [{
  title: 'Dedicated Funding Consultant',
  description: 'Get 1-on-1 guidance from an expert who knows exactly how to accelerate your raise.',
  icon: '/assets/icons/investors/dedicated-consultant.svg'
}, {
  title: 'Professional Pitch Deck Review',
  description: 'Receive detailed, actionable feedback to make your deck investor-ready.',
  icon: '/assets/icons/investors/pitch-deck-review.svg'
}, {
  title: 'Unlimited usage of the AI Investor Matching Agent',
  description: 'Search and connect with investors anytime, as often as you need.',
  icon: '/assets/icons/investors/matching-agent.svg'
}, {
  title: 'AI-powered Outreach for Custom Pitch Emails',
  description: 'Send smart, personalized emails designed to grab investor attention.',
  icon: '/assets/icons/investors/ai-outreach.svg'
}, {
  title: 'Contact 30 investor per day (w/open and click tracking)',
  description: 'Reach more investors daily while tracking every interaction.',
  icon: '/assets/icons/investors/contact-investors.svg'
}, {
  title: 'Select list of over 10,000 verified investors',
  description: 'Access a curated, up-to-date database of serious, verified investors.',
  icon: '/assets/icons/investors/investor-list.svg'
}];
const PricingCard = props => {
  const $ = _c(11);
  let t0;
  if ($[0] !== props.icon || $[1] !== props.title) {
    t0 = <Box color="colorPalette.border" fontSize="4xl" marginBottom={4}><Image alt={props.title} height={12} src={props.icon} /></Box>;
    $[0] = props.icon;
    $[1] = props.title;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== props.title) {
    t1 = <Heading color="colorPalette.fg" size="md" textAlign="center">{props.title}</Heading>;
    $[3] = props.title;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props.description) {
    t2 = <Text color="colorPalette.fg/70" fontSize="sm" fontWeight="500" textAlign="center">{props.description}</Text>;
    $[5] = props.description;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t0 || $[8] !== t1 || $[9] !== t2) {
    t3 = <Box background="colorPalette.container" borderRadius="md" boxShadow="sm" padding={6}><VStack align="center" gap={1}>{t0}{t1}{t2}</VStack></Box>;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
function _temp(_, index) {
  return <PricingCard key={index} {...PricingCardContent[index]} />;
}